module.exports = __webpack_public_path__ + "a79a96013d7727c0ed1bfac3c236ccdf.pdf";